// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Gp-z","outfitFeedbackSection":"Hp-z"};